import { render, staticRenderFns } from "./CreateDocumentCompetitors.vue?vue&type=template&id=13784ace&scoped=true&"
import script from "./CreateDocumentCompetitors.vue?vue&type=script&lang=js&"
export * from "./CreateDocumentCompetitors.vue?vue&type=script&lang=js&"
import style0 from "./CreateDocumentCompetitors.vue?vue&type=style&index=0&id=13784ace&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13784ace",
  null
  
)

export default component.exports